import { ServiceFeePayer } from '@/apis/payments/service_fee.schema'

export function getTotalServiceFeeToBePaidByApplicant(
  serviceFee: number,
  serviceFeePayer: ServiceFeePayer
) {
  if (serviceFeePayer === 'Applicant') {
    return serviceFee
  }

  return 0
}
